import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["cont", "handle"]

    close({ detail: { content } }) {
        console.log('tab', content)
        this.handleTargets.forEach(handle => {
            this.dispatch("close", {
                target: handle,
                detail: { content }
            })
        })
    }
}
